import React from "react";
import Img from "gatsby-image";
import { Flex } from "@src/components/Boxes";
import styled from "@emotion/styled";
import { graphql, useStaticQuery } from "gatsby";
import { css, Global } from "@emotion/core";
import normalize from "@src/styles/normalize";
import theme from "@src/styles/theme";
import { ThemeProvider } from "emotion-theming";
import Helmet from "react-helmet";
import { generatingFor } from "@src/utils/routes";
import { TranslationProvider } from "@src/components/translation/TranslationContext";
import { MobileDataContextProvider } from "@src/components/mobile/MobileDataContext";
import StyledLayoutMain from "@src/layouts/common/StyledLayoutMain";

const SimpleHeader = styled("nav")`
  background-color: #575b7d;
  height: 50px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  padding: 0 3rem;
  border-width: 0;
  z-index: 1000;
`;

function MobileLayout({ children, pageContext }) {
  generatingFor.locale = pageContext.localeStrings.currentLocale;
  const data = useStaticQuery(graphql`
    query {
      logo: file(name: { eq: "classdojo-logo-white@2x" }) {
        childImageSharp {
          fixed(width: 132, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `);

  const { logo } = data;
  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="https://static.classdojo.com/fonts/proxima/proximanova-default-stack.css" />
        <title>ClassDojo Mobile Web</title>
      </Helmet>
      <Global
        styles={css`
          ${normalize};
          #___gatsby,
          #gatsby-focus-wrapper,
          main,
          html,
          body {
            height: 100%;
            background-color: #3e425d;
          }
        `}
      />
      <TranslationProvider localeStrings={pageContext.localeStrings}>
        <ThemeProvider theme={theme}>
          <MobileDataContextProvider>
            <StyledLayoutMain id="main-page-container">
              <SimpleHeader>
                <Flex height="100%" alignItems="center">
                  <Img fixed={logo.childImageSharp.fixed} />
                </Flex>
              </SimpleHeader>
              {children}
            </StyledLayoutMain>
          </MobileDataContextProvider>
        </ThemeProvider>
      </TranslationProvider>
    </>
  );
}

export default MobileLayout;
